import { render } from "./GradingLevel.vue?vue&type=template&id=05ea1cae"
import script from "./GradingLevel.vue?vue&type=script&lang=js"
export * from "./GradingLevel.vue?vue&type=script&lang=js"

import "./GradingLevel.vue?vue&type=style&index=0&id=05ea1cae&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__